import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { SubscriptionsService } from 'app/API';
import { useState } from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './styles/Content';

type TProps = {
  billingAccountId: string;
  subscriptionId: string;
  planName: string;
  price: number;
  onSuccess: () => Promise<void>;
  onCancel: () => void;
  isSubmitting: boolean;
};

export const ConfirmSubscriptionCancellation = ({
  billingAccountId,
  subscriptionId,
  planName,
  onCancel,
  onSuccess,
}: TProps) => {
  const { call } = useAPI();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const innerSubmit = async () => {
    setIsSubmitting(true);
    await call(SubscriptionsService.remove({ baId: billingAccountId, subscriptionId }));
    await onSuccess();
  };

  return (
    <ModalWrapper width="480px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle data-testid="purchasePlan">Confirm</ModalTitle>
      <Content>
        <p className="description">
          You are about to cancel the &quot;{planName}&quot; plan. All issued licenses will be disabled at the end of
          your billing period. Are you sure you want to cancel?
        </p>

        <div className="buttonContainer">
          <OutlinedButton className="w-full" type="button" onClick={onCancel}>
            No
          </OutlinedButton>
          <Button
            className="w-full"
            data-testid="submitButton"
            type="submit"
            onClick={() => innerSubmit()}
            disabled={isSubmitting}
          >
            Yes
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
